/**
 * Máscara para formatação de CNPJ.
 * @param value O valor original sem máscara ou parcialmente mascarado.
 * @returns O valor formatado como CNPJ (XX.XXX.XXX/XXXX-XX).
 */
export var maskCNPJ = function (value) {
    return value
        .replace(/\D/g, "")
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .slice(0, 18);
};
/**
 * Máscara para formatação de CPF.
 * @param value O valor original sem máscara ou parcialmente mascarado.
 * @returns O valor formatado como CPF (XXX.XXX.XXX-XX).
 */
export var maskCPF = function (value) {
    return value
        .replace(/\D/g, "")
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1-$2")
        .slice(0, 14);
};
/**
 * Máscara para formatação de CEP.
 * @param value O valor original sem máscara ou parcialmente mascarado.
 * @returns O valor formatado como CEP (XXXXX-XXX).
 */
export var maskCEP = function (value) {
    return value
        .replace(/\D/g, "")
        .replace(/^(\d{5})(\d)/, "$1-$2")
        .slice(0, 9);
};
